import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import CalendarWeekDays from 'pages/app/vacation/partials/CalendarWeekDays'

function CalendarWeek ({ week, month, startOfWeek = null }) {
  return (
    <div key={week} className='week'>
      <div className='week-name cell'>
        <Translation name='generic.week_number_month' data={{ week: week, month: month }} />
      </div>
      <div className='days'>
        <CalendarWeekDays week={week} startOfWeek={startOfWeek} />
      </div>
    </div>
  )
}

export default React.memo(CalendarWeek)
